// extracted by mini-css-extract-plugin
export default {"divHeader":"RateView_divHeader__uHpIa"};